import { IconButton, Tooltip, type IconButtonProps } from '@mui/material';
import { forwardRef } from 'react';

interface ExtendedIconButtonProps extends IconButtonProps {
  tooltip?: React.ReactNode;
}

export const ExtendedIconButton = forwardRef<
  HTMLButtonElement,
  ExtendedIconButtonProps
>(function ExtendedIconButton(props, ref) {
  const { tooltip, children, ...iconButtonProps } = props;

  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton {...iconButtonProps} ref={ref} size='small' color='primary'>
          {props.children}
        </IconButton>
      </span>
    </Tooltip>
  );
});
